// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__kW9qj","subheader":"ReorderModal_subheader__2Aaml","listWrap":"ReorderModal_listWrap__3JzIP"};